import {
  GET_CONSUMER_TICKETS,
  SET_CONSUMER_TICKETS,
  API_ERROR,
} from "./actionTypes";

const initialState = {
  data: {},
  status: {},
};

const Tab = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONSUMER_TICKETS:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload.consumerId]: {
            loading: true,
            error: null,
            success: null,
          },
        },
      };
      break;
    case SET_CONSUMER_TICKETS:
      state = {
        ...state,
        data: {
          ...state.data,
          [action.payload.consumerId]: action.payload.data,
        },
        status: {
          ...state.status,
          [action.payload.consumerId]: {
            loading: false,
            error: null,
            success: true,
          },
        },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload.consumerId]: {
            loading: false,
            error: action.payload.error,
            success: false,
          },
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Tab;
